import React, {Component,useState} from "react";
import Leftmenu from "../element/leftmenu";
import Header from "../element/header";
import PageBreadcrumb from "../element/pagebreadcrumb";
import {DownloadOutlined} from "@ant-design/icons";
import {
    Layout,
    Col,
    Row,
    PageHeader,
    Button,
    Descriptions,
    Typography,
    InputNumber,
    Slider,
    Input,
    Space,
    DatePicker,
    List,
    Card,
    Avatar,
    Popover,
    Select,
    Popconfirm,
    Form,
    Radio,
    Switch,
    Cascader,
    TreeSelect,
    notification,
    message, Table, Tag, Statistic, Alert, Calendar, Modal
} from 'antd';
import { EditOutlined, DeleteOutlined, WechatOutlined } from '@ant-design/icons';
import 'moment/locale/zh-cn';
import moment from "moment";
import cookie from "react-cookies";
const { Title,Text } = Typography;
const { Content } = Layout;
const { Meta } = Card;

const DateList = (start) => {
    const [value, setValue] = useState(() => moment(start.end));
    const [selectedValue, setSelectedValue] = useState(() => moment(start.end));
    const onSelect = (newValue) => {
        setValue(newValue);
        setSelectedValue(newValue);
    };
    const onPanelChange = (newValue) => {
        setValue(newValue);
    };
    const getListData = (value,list) => {
        let listData;
        const date = value.format('YYYY-MM-DD');
        for (let i = 0; i < list.length; i++) {
            if(date == list[i].clientprice_date){
                listData = list[i].clientprice_value;
            }
        }
        return listData || '';
    };
    const dateCellRender = (value) => {
        const listData = getListData(value,start.date);
        return (
            <>
                {
                    listData
                    ?

                        <Tag color="#108ee9">
                            {listData}元/吨
                        </Tag>
                        :
                        ''
                }
            </>
        );
    };
    const onFinish = (values) => {

        function queryParse(query){
            let queryText = "";
            for(let key in query){
                queryText += `${key}=${query[key]}&`;
            }
            return queryText.slice(0,-1);
        }
        var list = {};
        list.clientprice_value = values.value ? values.value : 0;
        list.clientprice_date = selectedValue.format('YYYY-MM-DD');
        if(start.id&&start.type){
            list.clientprice_client = start.id;
            list.clientprice_stock = start.type
            console.log(list)
            fetch("https://pd.pokemonbye.com:8084/api/insertsellclientprice",
                {
                    method:'post',
                    body:queryParse(list),
                    headers:{
                        'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                    }
                })
                .then(res => res.json())
                .then(
                    (result) => {
                        console.log(result)
                        openNotification();
                        window.location.reload();
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }else{

        }
    };
    return (
        <>
            <Card title=" " bordered={false}>
                <Space>
                    <Form
                        labelCol={{
                            span: 10,
                        }}
                        wrapperCol={{
                            span: 20,
                        }}
                        layout="horizontal"
                        onFinish={onFinish}
                    >
                        <Form.Item label="当前选择日期" name="date">
                            {selectedValue.format('YYYY-MM-DD')}
                        </Form.Item>
                        <Form.Item label="设置日期价格" name="value"
                                   rules={[
                                       {
                                           required: true,
                                           message: '请输入金额!',
                                       },
                                   ]}>
                            <InputNumber prefix="￥" addonAfter="元"/>
                        </Form.Item>
                        <Form.Item
                            wrapperCol={{
                                offset: 4,
                                span: 2,
                            }}
                        >
                            <Button type="primary" htmlType="submit">设置</Button>
                        </Form.Item>
                    </Form>
                </Space>
            </Card>
            <Calendar onSelect={onSelect} onPanelChange={onPanelChange} dateCellRender={dateCellRender} validRange={[moment(start.start),moment(start.end)]}/>
        </>
    );
};
const openNotification = () => {
    notification.open({
        message: '提交成功',
        description:
            '添加成功',
        onClick: () => {
            console.log('提交成功');
        },
    });
};
const info = () => {
    message.info('This is a normal message');
};
const columns = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '金额（元）',
        dataIndex: 'fund_value',
        key: 'fund_value',
    },
    {
        title: '状态',
        dataIndex: 'name',
        key: 'name',
        render: (_, { fund_type }) => (
            <>
                {fund_type == 1
                    ?
                    <Tag color='success'>
                        增加
                    </Tag>
                    :
                    <Tag color='error'>
                        减少
                    </Tag>
                }
            </>
        ),
    },
    {
        title: '备注',
        dataIndex: 'fund_intro',
        key: 'fund_intro',
    },
    {
        title: '时间',
        dataIndex: 'fund_pubtime',
        key: 'fund_pubtime',
    }
];
const columnslist = [
    {
        title: '序号',
        dataIndex: 'key',
        key: 'key',
    },
    {
        title: '单价（元/吨）',
        dataIndex: 'clientprice_value',
        key: 'clientprice_value',
    },
    {
        title: '生效时间',
        dataIndex: 'clientprice_date',
        key: 'clientprice_date',
    }
];
const Load = (that,type) => {
    var id = that.state.list.fund_client
    const start = that.state.start
    const end = that.state.end
    if(type) {
        fetch("https://pd.pokemonbye.com:8084/api/getsellclientpricedatebyidtype?start="+start+"&end="+end+"&id=" + id+"&type=" + type)
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    console.log(array)
                    if(array!=null&&array.length>0){

                    }
                    that.setState({
                        isLoaded: true,
                        date: array
                    });
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    that.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
}
const App = (value) => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [content, setContent] = useState('查询中');
    const [content2, setContent2] = useState('');
    const showModal = () => {
        setIsModalOpen(true);
        setTimeout(() => {
        }, 1000);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    return (
        <>
            <Button onClick={showModal}>
                历史
            </Button>
            <Modal title="价格历史" open={isModalOpen}
                   footer={[
                       <Button key="back" onClick={handleCancel}>
                           关闭
                       </Button>
                   ]}>

                <Table bordered={true} columns={columnslist} dataSource={value.id}/>
            </Modal>
        </>
    );
};
class PageFinSetsPrice extends Component{

    constructor(props) {
        super(props);
        const params = new URLSearchParams(window.location.search);
        const id = params.get("id");
        const date = params.get("date");
        const type = params.get("type");
        let userId = cookie.load('userId');/*
        let start = moment(date).subtract(1,'months').format('YYYY-MM') + '-26'*/
        let start = moment(date).format('YYYY-MM') + '-01'
        let end = moment(date).add(1, 'month').startOf('month').format('YYYY-MM-DD');
        this.state = {
            title: "历史价格修改",
            county: [],
            id: id,
            type: type,
            userId: userId,
            sum: 0,
            list: [],
            start: start,
            end: end,
            date:[],
            name:0,
            stock:0
        };
    }

    componentDidMount() {
        var id = this.state.id
        if(id){
            fetch("https://pd.pokemonbye.com:8084/api/getsellfundbyid?id=" + id)
                .then(res => res.json())
                .then(
                    (result) => {
                        let array = result.data;
                        if(array!=null&&array.length>0){
                            this.setState({
                                isLoaded: true,
                                list: array[0]
                            });
                        }
                    },
                    // 注意：需要在此处处理错误
                    // 而不是使用 catch() 去捕获错误
                    // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                    (error) => {
                        this.setState({
                            isLoaded: true,
                            error
                        });
                    }
                )
        }
        fetch("https://pd.pokemonbye.com:8084/api/getsellstock")
            .then(res => res.json())
            .then(
                (result) => {
                    let array = result.data;
                    if(array!=null&&array.length>0){
                        for (let i = 0; i < array.length; i++) {
                            array[i].value = array[i].id;
                            array[i].label = array[i].stockname;
                        }
                        this.setState({
                            isLoaded: true,
                            options: array
                        });
                    }
                },
                // 注意：需要在此处处理错误
                // 而不是使用 catch() 去捕获错误
                // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                (error) => {
                    this.setState({
                        isLoaded: true,
                        error
                    });
                }
            )
    }
    formRef = React.createRef();
    render() {
        const handleChange = (value) => {
            this.setState({
                type: value
            });
            Load(this,value)
        };
        const onFinish = (values) => {

            function queryParse(query){
                let queryText = "";
                for(let key in query){
                    queryText += `${key}=${query[key]}&`;
                }
                return queryText.slice(0,-1);
            }
            var list = {};
            list.clientprice_value = values.value ? values.value : 0;
            if(this.state.id){
                list.clientprice_client = this.state.list.fund_client;
                list.clientprice_stock = this.state.type;
                list.clientprice_type = 1;
                list.clientprice_date = moment().format('YYYY-MM-DD');
                fetch("https://pd.pokemonbye.com:8084/api/insertsellclientprice",
                    {
                        method:'post',
                        body:queryParse(list),
                        headers:{
                            'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                        }
                    })
                    .then(res => res.json())
                    .then(
                        (result) => {
                            openNotification();
                            window.location.reload();
                        },
                        // 注意：需要在此处处理错误
                        // 而不是使用 catch() 去捕获错误
                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                        (error) => {
                            this.setState({
                                isLoaded: true,
                                error
                            });
                        }
                    )
            }
        };
        const App = (value) => {
            const [isModalOpen, setIsModalOpen] = useState(false);
            const [content, setContent] = useState('查询中');
            const [content2, setContent2] = useState('');
            const [sum, setSum] = useState('');
            const [num, setNum] = useState('');
            const showModal = () => {
                setIsModalOpen(true);
                setTimeout(() => {
                    fetch("https://pd.pokemonbye.com:8081/api/getweightmaxbyname?name=" + value.name + "&start=" + value.start + "&end=" + value.end)
                        .then(res => res.json())
                        .then(
                            (result) => {
                                let array = result.data;
                                var sumvalue = 0
                                if(array!=null&&array.length>0){
                                    for (let i = 0; i < array.length; i++) {
                                        array[i].key = i + 1
                                        sumvalue += parseFloat(array[i].value)
                                    }
                                }
                                setContent("采购量（吨）："+sumvalue.toFixed(2))
                                setNum(parseFloat(sumvalue.toFixed(2)))

                                fetch("https://pd.pokemonbye.com:8084/api/getsellclientdate?client=" + value.id + "&start=" + value.start + "&end=" + value.end)
                                    .then(res => res.json())
                                    .then(
                                        (result) => {
                                            var summax = 0
                                            if(result!=null&&result.length>0){
                                                for (let i = 0; i < array.length; i++) {
                                                    array[i].key = i + 1
                                                    for (let j = 0; j < result.length; j++) {
                                                        if(array[i].time.substring(0,10) == result[j].date){
                                                            for(let k = 0; k < result[j].list.length; k++){
                                                                if(array[i].stock == result[j].list[k].stockname){
                                                                    array[i].price = result[j].list[k].value
                                                                    array[i].max = array[i].price * array[i].value
                                                                }
                                                            }
                                                        }
                                                    }
                                                    summax += array[i].max
                                                }

                                            }
                                            setContent2("采购金额（元）："+value.price + " => " + summax.toFixed(2))
                                            setSum(parseFloat(summax.toFixed(2)))
                                        },
                                        // 注意：需要在此处处理错误
                                        // 而不是使用 catch() 去捕获错误
                                        // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                                        (error) => {
                                        }
                                    )
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                            }
                        )
                }, 1000);
            };
            const handleOk = () => {
                    setIsModalOpen(false);

                    function queryParse(query){
                        let queryText = "";
                        for(let key in query){
                            queryText += `${key}=${query[key]}&`;
                        }
                        return queryText.slice(0,-1);
                    }
                    var list = value.list;
                list.fund_value = sum ? sum : value.price;
                list.fund_num = num ? num : list.fund_num;

                    fetch("https://pd.pokemonbye.com:8084/api/setsellfund",
                        {
                            method:'post',
                            body:queryParse(list),
                            headers:{
                                'Content-Type': "application/x-www-form-urlencoded; charset=UTF-8",
                            }
                        })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                //window.location.reload();
                                openNotification();
                                //window.location.href="/pagefinsetshis?id=" + list.fund_id
                            },
                            // 注意：需要在此处处理错误
                            // 而不是使用 catch() 去捕获错误
                            // 因为使用 catch 去捕获异常会掩盖掉组件本身可能产生的 bug
                            (error) => {
                                this.setState({
                                    isLoaded: true,
                                    error
                                });
                            }
                        )
            };
            const handleCancel = () => {
                setIsModalOpen(false);
            };
            return (
                <>
                    <Button type="primary" onClick={showModal}>
                        查看并确认
                    </Button>
                    <Modal title={value.date} open={isModalOpen}
                           footer={[
                               <>
                               <Button key="sub" onClick={handleOk} type="primary">
                                   确认修改
                               </Button>
                               <Button key="back" onClick={handleCancel}>
                                   关闭
                               </Button>
                               </>
                           ]}>
                        <p>{content}</p>
                        <p>{content2}</p>
                    </Modal>
                </>
            );
        };
        return (
            <div>
                <Leftmenu />
                <div className="mainpanel">
                    <Header />
                    <PageBreadcrumb title={this.state.title}/>
                    <Content className="site-layout-background">
                        <div className="site-page-header-ghost-wrapper">
                            <PageHeader
                                ghost={false}
                                onBack={() => window.history.back()}
                                title={this.state.title}
                            >
                                <Row>
                                    <Col span={2}></Col>
                                    <Col><Title level={2}>{this.state.list.fund_clientname}</Title></Col>
                                    <Col span={1}></Col>
                                    <Col><Select
                                        defaultValue="请选择"
                                        style={{
                                            width: 220,
                                            top: 20
                                        }}
                                        onChange={handleChange}
                                        options={this.state.options}
                                    /></Col>
                                    <Col span={1}></Col>
                                    <Col
                                         style={{
                                             top: 20
                                         }}>
                                        <App type="primary" name={this.state.list.fund_clientname} id={this.state.list.fund_client} start={this.state.start} end={this.state.end} date={moment(this.state.start).format('YYYY-MM')} price={this.state.list.fund_value} list={this.state.list}>查看并确认</App>
                                    </Col>
                                </Row>
                                <DateList start={this.state.start} end={this.state.end} date={this.state.date} id={this.state.list.fund_client} type={this.state.type}/>
                            </PageHeader>
                        </div>
                    </Content>
                </div>
            </div>
        );
    }
}

export default PageFinSetsPrice;


